import { Box } from '@mui/material';

const DetailsRowVolet4 = () => {
  return (
    <Box className="flex flex-col w-[max-content]">
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Renforcer la contribution et l'impact de la recherche collaborative dans la résolution des
          problématiques environnementales
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Conventions de partenariat établies
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de suivi des projets financés{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de suivi des projets financés{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de suivi et d'évaluation de mi-parcours des projets financés{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.2
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre d’emplois verts créés/maintenus avec l’appui de l’UE{' '}
          <span className="text-green-600"> (désagrégés par genre)</span>
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Questionnaire/ enquête post-projets
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Un système efficace de formation aux compétences vertes est mis en œuvre
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Conventions établies{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de suivi des projets{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de suivi (annuels et finaux) des projets{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Les activités de la recherche sont plus appliquées et mieux orientées vers les besoins
          socioéconomiques{' '}
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Lignes directrices des appels lancés{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapport d’évaluation des propositions{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de suivi et d’évaluation à mi-parcours des projets{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de suivi et d’évaluation à mi-parcours des projets financés{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Les municipalités et collectivités locales sont appuyées dans leurs mandats de
          développement notamment dans le domaine de l’environnement
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de suivi des projets financés{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapport de la mission d’accompagnement{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          BdD jeunes sélectionnés pour incubation et rapport de la mission d’accompagnement{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          La formation académique dans le secteur de l’environnement est mieux adaptée aux besoins
          socioéconomiques
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.3.3
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Référentiel Métier-Référentiel Compétences (REMREC ) pour le secteur de l’environnement
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          L’employabilité des diplômés dans le secteur de l’environnement est renforcée
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Une recherche appliquée au service de son environnement{' '}
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.3.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de projets financés pour une recherche scientifique appliquée dans le secteur de
          l’environnement{' '}
          <span className="text-red-600">(? cible ARESSE: 25-30, Programme: 15 ?)</span>
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.3.2
          <span className="text-red-500">partiel</span>
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de centres de recherche impliqués dans les projets appliqués{' '}
          <span className="text-red-500">(cible: 15)</span> Nombre d’organismes socioéconomiques
          impliqués dans les projets appliqués{' '}
          <span className="text-red-500">
            (cible: 15)(? cible ARESSE: 15+15=30, Programme: 80?)
          </span>
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.3.2
          <span className="text-red-500">partiel</span>
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de centres de recherche impliqués dans les projets appliqués{' '}
          <span className="text-red-500">(cible: 15)</span> Nombre d’organismes socioéconomiques
          impliqués dans les projets appliqués{' '}
          <span className="text-red-500">
            (cible: 15)(? cible ARESSE: 15+15=30, Programme: 80?)
          </span>
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          La culture environnementale est appuyée{' '}
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Les partenariats entre le monde de la recherche et le monde socio-économique et
          employabilité des docteurs renforcés{' '}
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.2.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de conventions MOBIDOC Post-Doc établies
          <span className="text-red-500">
            (cible: 15)(? cible ARESSE: 15+15=30, Programme: 80?)
          </span>
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.2.2
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de municipalités bénéficiaires du dispositif MOBIDOC{' '}
          <span className="text-red-500">
            (cible: 15)(? cible ARESSE: 15+15=30, Programme: 80?)
          </span>
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
    </Box>
  );
};

export default DetailsRowVolet4;
